import React from 'react'
import JobsDetail from '../../components/jobsdetail/JobsDetail'

const JobDetail = () => {
    return (
        <>
            <JobsDetail />
        </>
    )
}
export default JobDetail
